export default "__VITE_ASSET__BrlYCaHv__"